import { render, staticRenderFns } from "./standardPrice.vue?vue&type=template&id=02392b58&scoped=true"
import script from "./standardPrice.vue?vue&type=script&lang=js"
export * from "./standardPrice.vue?vue&type=script&lang=js"
import style0 from "./standardPrice.vue?vue&type=style&index=0&id=02392b58&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02392b58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02392b58')) {
      api.createRecord('02392b58', component.options)
    } else {
      api.reload('02392b58', component.options)
    }
    module.hot.accept("./standardPrice.vue?vue&type=template&id=02392b58&scoped=true", function () {
      api.rerender('02392b58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/standard/standardPrice.vue"
export default component.exports